/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MyLibraryEnrollmentViewModel } from "../types/MyLibraryEnrollmentViewModel.ts";
import { eEnrollmentStatusSchema } from "./eEnrollmentStatusSchema.ts";

export const myLibraryEnrollmentViewModelSchema = z.object({
  classStudentId: z.optional(z.number().int().describe("ID da turma.")),
  classStudentName: z
    .string()
    .describe(
      "Nome da turma na cultura solicitada, com retorno para pt-BR e para a descrição da turma quando não houver tradução.",
    )
    .nullish(),
  enrollmentStatus: z.optional(
    z
      .lazy(() => eEnrollmentStatusSchema)
      .describe(
        "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
      ),
  ),
  enrollmentStatusName: z
    .string()
    .describe(
      "Descrição do status de matrícula já resolvida na cultura solicitada.",
    )
    .nullish(),
}) as unknown as ToZod<MyLibraryEnrollmentViewModel>;
